export default "__VITE_ASSET__erzGIyfX__"